/*
 * @Author: aalizzwell
 * @Date: 2020-02-27 11:33:41
 * @Last Modified by: aalizzwell
 * @Last Modified time: 2020-02-27 11:34:16
 */
// tslint:disable: no-string-literal

import { Directive, OnInit, OnChanges, SimpleChanges, Input, HostListener, Type, Output, EventEmitter, OnDestroy } from '@angular/core';
import { BindingData, BindingList, FrameContext, Change, ChangeType, ComponentType } from '@farris/devkit';
import { TreeTableComponent, TreeNode } from '@farris/ui-treetable';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { FarrisTreetableFormatService } from '../format/index';
import { TreeNodeBuilderFactory } from './tree_table_node_builder/tree_node_builder_factory';

/**
 * æ è¡¨æ ¼ç»å®æä»¤
 */
@Directive({
  selector: '[farrisTreeTableBinding]'
})
class FarrisTreeTableBindingDirective implements OnInit, OnChanges, OnDestroy {
  /**
   * æ å­å¨ç©ºé´
   */
  private storage: any;
  private renderSubject: Subject<any> = new Subject<any>();
  private builder: Type<any>;
  private treeNodesBuilder: any;
  private destorySignal: Subject<any>;
  private disposed: boolean;
  /**
   * åçº§ç ä¿¡æ¯çkey
   */
  // tslint:disable-next-line: no-input-rename
  @Input('farrisHierarchyInfoKey')
  public hierarchyInfoKey: string;

  /* è¡æ ·å¼ */
  @Input()
  rowClassName: (context: any) => any;

  /* ååååæ ¼æ ·å¼ */
  @Input()
  cellClassName: (data: any, field: any) => any;
  /**
   * å¯ç¨èç¹åé¡µ
   */
  // @Input('enableNodePagination')
  // public enableNodePagination: boolean;
  /**
   * èç¹åé¡µå¤§å°
   */
  @Input('nodePageSize')
  public nodePageSize: number = 100;
  /**
   * ç»å®æ°æ®
   */
  private get bindingData(): BindingData {
    return this.frameContext.bindingData;
  }

  /**
   * ç»å®æ°æ®åè¡¨
   */
  private get bindingList(): BindingList {
    // @todoï¼åªæ¯æä¸»è¡¨ï¼æ²¡æå¤çbindingPath
    return this.bindingData.list;
  }


  /* è®¾ç½®è¡æ ·å¼ */
  @Output()
  rowClass: EventEmitter<any> = new EventEmitter<any>();

  /* è®¾ç½®åæ ·å¼ */
  @Output()
  cellClass: EventEmitter<any> = new EventEmitter<any>();

  private _PROP: any = null;
  private listeners: any[];
  private get prop() {
    return this._PROP;
  }
  private set prop(value) {
    this._PROP = value;
  }
  /**
   * è·åå½åvm
   */
  private get viewModel() {
    return this.frameContext.viewModel;
  }
  /**
   * æé å½æ°
   */
  constructor(
    private treeTable: TreeTableComponent,
    private treetableFormatSer: FarrisTreetableFormatService,
    private frameContext: FrameContext
  ) {
    this.listeners = [];
    this.storage = [];
    this.viewModel.uiState.setPropertyValue('ids', this.treeTable.checkValues);
    this.renderSubject.pipe(
      debounceTime(500)
    ).subscribe(() => {
      this.bindData();
    });
    this.disposed = false;
    this.destorySignal = new Subject<any>();
  }
  ngOnDestroy(): void {
    this.disposed = true;
    this.destorySignal.next();
    this.destorySignal.complete();
  }

  /**
   * æä»¤åå§å
   */
  ngOnInit() {
    // å°åçº§ç ä¿¡æ¯ä¿å­å°root-componentï¼èéæ´ä¸ªè¡¨åçapp-context
    const virtualRootFrameContext = this.frameContext.getVirtualRootFrameContext();
    virtualRootFrameContext.setParam('hierarchyInfoKey', this.hierarchyInfoKey);
    this.bindData();
    this.bindingData.changes.pipe(takeUntil(this.destorySignal)).subscribe((change: Change) => {
      if (change && (change.type === ChangeType.ValueChanged || change.type === ChangeType.PaginationInfoChange)) {
        this.renderSubject.next(change);
      } else {
        this.bindData();
      }
      // è®¾ç½®å½åè¡
      const currentId = this.bindingList.currentId;
      if (!this.frameContext.bindingData.rowSelectedEventSuspend && currentId) {
        this.setSelectedIdToTree(this.bindingList.currentId, change);
      }
      this.updateCheckedRows(change);
    });

    // è®¾ç½® æ è¡¨ æ ¼å¼å
    this.treetableFormatSer.setFormat(this.treeTable);

    /* è¡æ ·å¼ */
    this.rowClass.emit(this.treeTable);

    /* åæ ·å¼  ååæ ¼æ ·å¼ */
    this.cellClass.emit(this.treeTable);
    this.setComponentRef();
    this.setNodePaginationInfo();
    this.registerEvent();
    if (this.frameContext && this.frameContext.frameComponent) {
      this.frameContext.frameComponent.componentType = ComponentType.farrisTreeTalbeComponent;
    }
    if (this.frameContext && this.frameContext.appContext && this.frameContext.appContext.destorySignal) {
      this.frameContext.appContext.destorySignal.subscribe(() => {
        this.dispose();
      });
    }
  }

  /**
   * æä»¤è¾å¥åæ´
   */
  ngOnChanges(changes: SimpleChanges) {
  }
  private registerEvent() {
    this.treeTable.columnSorted.subscribe((event: { sortName: string, sortOrder: string; }) => {
      const { sortName = null, sortOrder = null } = event;
      const remoteSort = this.treeTable.remoteSort;
      if (remoteSort === false) {
        if (sortName && sortOrder) {
          this.bindingList.sortBy(sortName, sortOrder);
        }
      }
      this.bindData();
    });
  }
  /**
   * æ¶éæ ç»ä»¶å®ä¾
   */
  private setComponentRef() {
    const appContext = this.viewModel && this.viewModel.frameContext && this.viewModel.frameContext.getFormAppContext();
    const frameId = this.viewModel && this.viewModel.frameContext && this.viewModel.frameContext.frameId;
    const id = this.treeTable && this.treeTable.el.nativeElement.id || null;
    // å¦æframeIdä¸å­å¨ætreetableæ²¡æidå±æ§ï¼è¯´æä¸ç¬¦åä½¿ç¨åºæ¯
    if (!frameId || !id) {
      return;
    }
    // è®¾ç½®é¢å¤å±æ§ä»¥ç¨äºåç»­å¤æ­
    // TODO: åºå¨ç»ä»¶ç®¡çä¸­æ è¯åºæ¯ä¸ªç»ä»¶çç±»åï¼ä»èå®ç°éè¿ç±»åè·åææç»ä»¶çæ¹æ³
    this.treeTable['__component_type__'] = 'TreeGridComponent';
    const map = appContext && appContext.componentRefs && appContext.componentRefs.get(frameId) || new Map<string, any>();
    appContext && appContext.componentRefs && appContext.componentRefs.set(frameId, map.set(id, this.treeTable));
  }

  private setNodePaginationInfo() {
    if (this.frameContext) {
      const enableNodePagination = this.treeTable.paginationForChildren || false; // this.enableNodePagination || false;
      this.frameContext.params.set('enableNodePagination', enableNodePagination);
      const nodePageSize = this.nodePageSize || 0;
      this.frameContext.params.set('nodePageSize', nodePageSize);
    }
  }

  /**
   * ç»å®æ°æ®
   */
  private bindData() {
    if (this.disposed) {
      return;
    }
    this.listeners = [];
    const oldTreeNodes = this.treeTable.data;
    const treeNodesData = this.bindingList.toJSON({ ignoreMultiLangInput: true });
    // if (!this.shouldComponentUpdate(treeNodesData)) {
    //   return;
    // }
    this.prop = treeNodesData;

    let treeNodes: TreeNode[] = [];
    if (!!treeNodesData && treeNodesData.length > 0) {
      const hierarchyInfo = treeNodesData[0][this.hierarchyInfoKey];
      let builder: Type<any> = this.builder;
      if (!builder) {
        this.builder = TreeNodeBuilderFactory.getBuilder(hierarchyInfo);
        builder = this.builder;
      }
      // æå¡å¨è¿åçåçº§èç¹ä¿¡æ¯å¹éä¸å°ç°æå·¥åéé¢çä»»ä½ä¸ç§æåµãç¡®è®¤æ°å çbuilderå·²ç»å¨å·¥åä¸­æ³¨å
      if (builder == null) {
        throw new Error('TreeTable builder is null!');
      }
      let expandLevel = -1;
      const treeExpandLevel = this.treeTable['expandLevel'];
      if (typeof treeExpandLevel !== 'undefined') {
        expandLevel = treeExpandLevel;
      }
      const virtualRootFrameContext = this.frameContext.getVirtualRootFrameContext();
      const nodesShouldExpand = (virtualRootFrameContext.params.get('_DEVKIT_expandRowIds') || '').split(',') || [];
      const context = {
        expandLevel,
        addTreeLoadCompleteListener: this.addTreeLoadCompleteListener.bind(this),
        component: this.treeTable,
        storage: this.storage,
        nodesShouldExpand: nodesShouldExpand,
        frameContext: this.frameContext,
      };
      //if (!this.treeNodesBuilder) {
      this.treeNodesBuilder = new builder(
        treeNodesData, oldTreeNodes,
        this.bindingList.primaryKey, this.hierarchyInfoKey, context
      );
      //}
      // this.treeNodesBuilder.updateTreeNode(treeNodesData, oldTreeNodes);
      treeNodes = this.treeNodesBuilder.build();
    }
    this.treeTable.data = treeNodes;
    // è®¾ç½®åé¡µä¿¡æ¯
    this.updatePageInfo(this.treeTable);
    this.onTreeLoadComplete();
    // è®¾ç½®å½åè¡
    const currentId = this.bindingList.currentId;
    const componentCurrentId = this.getSelectedIdFromTree();
    if (currentId && componentCurrentId !== currentId && !this.frameContext.bindingData.rowSelectedEventSuspend) {
      this.treeTable.clearSelections();
      this.treeTable.selectNode(currentId);
    }
  }
  private onTreeLoadComplete() {
    if (this.listeners && this.listeners.length > 0) {
      this.listeners.forEach(listener => {
        listener();
      });
    }
  }
  private addTreeLoadCompleteListener(listener: any) {
    this.listeners.push(listener);
  }
  private shouldComponentUpdate(newProp: any) {
    if (JSON.stringify(this.prop) === JSON.stringify(newProp)) {
      return false;
    }
    return true;
  }
  /**
   * ä»æ ç»ä»¶ä¸è·åéä¸­è¡çid
   */
  private getSelectedIdFromTree(): string {
    const selectedRow = this.treeTable.selectedRow;
    return selectedRow ? selectedRow.data['id'] : null;
  }

  /**
   * è®¾ç½®TreeTableçå½åè¡
   */
  private setSelectedIdToTree(selectedId: string, change: Change): void {
    if (!selectedId) {
      return;
    }
    // å¦ææ°çcurrentIdåæ ä¸çselectedIdä¸ä¸è´ï¼éç½®æ çå½åè¡
    const oldSelectedId = this.getSelectedIdFromTree();
    const nodePageChanged = this.frameContext.params.get('_NODE_PAGE_CHANGED_') || false;
    if (!oldSelectedId && nodePageChanged) {
      this.frameContext.params.delete('_NODE_PAGE_CHANGED_');
      return;
    }
    const isMatch = change && (change.path.toString() === this.viewModel.bindingPath.split('/').filter((p) => p).toString());
    if (oldSelectedId !== selectedId || (change && change.type === ChangeType.Load && isMatch)) {
      this.treeTable.clearSelections();
      this.treeTable.selectNode(selectedId);
    }
  }

  /**
   * è®¾ç½®BindingListçCurrentId
   */
  private setCurrentIdToBindingList(selectedId: string): void {
    const oldCurrentId = this.bindingData.list.currentId;
    // åéæ¨¡å¼ä¸å°å½åè¡è®¾ç½®å°ids
    if (!this.treeTable.multiSelect) {
      this.setChecks(selectedId);
      this.setCheckedRows([selectedId]);
    }
    if (oldCurrentId === selectedId) {
      return;
    }
    this.bindingData.list.setCurrentId(selectedId, true);
  }
  private updateCheckedRows(changes: Change) {
    if (changes.type === ChangeType.Load) {
      this.setCheckedRows();
    } else if (changes.type === ChangeType.ValueChanged || changes.type === ChangeType.Remove) {
      const ids = this.getChecks();
      if (changes.id && ids.includes(changes.id)) {
        this.setCheckedRows();
      }
    }
  }
  /**
   * æ´æ°å¾éè¡æ°æ®
   */
  protected setCheckedRows(ids?: string[]) {
    if (typeof ids === 'undefined') {
      ids = this.viewModel.uiState['ids'] || [];
    }
    if (!Array.isArray(ids)) {
      return;
    }
    const list = this.bindingList.toJSON();
    const rows: Map<string, any> = this.viewModel.uiState['rows'] || new Map<string, any>();

    const result = new Map<string, any>();
    ids.forEach((id: any) => {
      const item = list.find(item => item[this.bindingList.primaryKey] === id);
      const otherPageItem = rows.get(id);
      if (item) {
        result.set(id, item);
      } else if (otherPageItem) {
        result.set(id, otherPageItem);
      }
    });
    this.viewModel.uiState.setPropertyValue('rows', result);
  }
  /**
   * è®¾ç½®idsåé
   * @param idOrIds id or ids
   */
  protected setChecks(idOrIds: string | string[]) {
    if (typeof idOrIds === 'string') {
      idOrIds = idOrIds.split(',').filter(p => p);
    }
    this.viewModel.uiState.setPropertyValue('ids', idOrIds);
  }
  /**
   * è·åå¾éè¡idæ°ç»
   * @returns
   */
  protected getChecks(): string[] {
    return this.viewModel.uiState['ids'] || [];
  }
  private dispose() {
    this.listeners = [];
    this.prop = null;
  }
  /**
   * è·ååé¡µä¿¡æ¯
   */
  private getPagingInfo() {
    const bindingPath = this.viewModel.bindingPath;
    const bindingData = this.viewModel.bindingData;
    let pagingInfo = bindingData.pagingInfo;
    if (bindingPath === '/') {
      return pagingInfo;
    } else {
      const bindingPaths = bindingPath.substr(1).split('/').filter(item => !!item && item.length > 0).map(item => {
        return item.substring(0, item.length - 1);
      });
      bindingPaths.forEach(path => {
        pagingInfo = pagingInfo && pagingInfo[path];
      });
      return pagingInfo;
    }
  }
  private updatePageInfo(treeTable: TreeTableComponent) {
    const { pageIndex, pageSize, total } = this.getPagingInfo();
    if (pageSize === 0) {
      treeTable.pagination = false;
      return;
    }
    treeTable.pagination = true;
    treeTable.updatePageInfo({ pageIndex, pageSize, total });
  }
  //#region ç»ä»¶äºä»¶
  /**
   * è¡åæ¢
   */
  @HostListener('nodeSelected', ['$event'])
  public selectionChangeHandler(event: any) {
    if (event && event.node && event.node.hasOwnProperty('data')) {
      const idField = this.treeTable.idField;
      const id = event.node.data[idField];
      this.setCurrentIdToBindingList(id);
    }
  }
  /**
   * å¾éèç¹åçåå
   * @param event event
   */
  @HostListener('checkValuesChange', ['$event'])
  public checkValuesChange(event: any) {
    // this.viewModel.uiState.setPropertyValue('ids', this.treeTable.checkValues);
    this.setChecks(this.treeTable.checkValues);
    this.setCheckedRows();
  }
  /**
   * å°è¢«å±å¼çèç¹è®¾ç½®ä¸ºå½åè¡
   */
  @HostListener('expand', ['$event'])
  public expandHandler(event: any) {
    const selectedId = event.data['id'];
    const virtualRootFrameContext = this.frameContext.getVirtualRootFrameContext();
    // å±å¼æ¶ä¸åéä¸­
    // this.setSelectedIdToTree(selectedId);
    const expandNodes = virtualRootFrameContext.getParam('TREE_LATEST_EXPANDED_ID') || [];
    expandNodes.push(selectedId);
    virtualRootFrameContext.setParam('TREE_LATEST_EXPANDED_ID', expandNodes);
  }
  @HostListener('pageChanged', ['$event'])
  public onPageChanged(event: any) {
    let { pageSize = 20, pageIndex = 1 } = event || {};
    if (pageIndex < 1) {
      pageIndex = 1;
    }
    const skip = (pageIndex - 1) * pageSize;
    this.bindingData.setPagingInfo(skip, pageSize, this.bindingData.bindingPath);
  }
  @HostListener('pageSizeChanged', ['$event'])
  public onPageSizeChanged(event: any) {
    const pageSize = event ? event : 20;
    const skip = 0;
    this.bindingData.setPagingInfo(skip, pageSize, this.bindingData.bindingPath);
  }
  /**
   * èç¹é¡µç åæ¢äºä»¶
   * @param event event
   */
  @HostListener('childsPageChanged', ['$event'])
  public onNodePageChanged(event: any) {
    const { pageIndex = 1, pageSize = this.nodePageSize, node = {} } = event;
    const id = node && node.id || null;
    if (id) {
      const virtualRootFrameContext = this.frameContext.getVirtualRootFrameContext();
      const expandNodes = virtualRootFrameContext.getParam('TREE_LATEST_EXPANDED_ID') || [];
      expandNodes.push(id);
      virtualRootFrameContext.setParam('TREE_LATEST_EXPANDED_ID', expandNodes);
      this.frameContext.params.set(`_NODE_${id}_PAGE_INDEX_`, pageIndex);
      this.frameContext.params.set(`_RELOAD_CHILDREN_`, true);
      this.frameContext.params.set('_NODE_PAGE_CHANGED_', true);
    }
  }
  //#endregion
}

export { FarrisTreeTableBindingDirective };
